module.exports = __webpack_public_path__ + "static/black-tee-b4ef5694983a8afb88dcf0677a60301a.png";